const deliveryStatuses = {
  notAvailable: 'Not available yet',
  processing: 'Processing',
  inTransit: 'In Transit',
  outForDelivery: 'Out for Delivery',
  delivered: 'Delivered',
  failure: 'Failure',
}


export default deliveryStatuses
